import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";

export class ValdnWidgetsIPModel extends WidgetsAbstract {
    readonly icon: string = 'fact_check';
    readonly name: string = 'IP';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.VALDN_IP;
    readonly template = 'ip';
    readonly badge: string = 'VI';
    readonly placeholderClassName: string = 'valdn-placeholder';
    type: string = 'valdn';

    cloneFrom(origin: WidgetsAbstract) : WidgetsAbstract {
        return this;
    }        
}
